import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class BestbuyService extends ApiService {
    entityType = EntityType.BESTBUY;
    url = 'api/marketplace/bestbuy/search/';
}
